// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__FqAWi","footer__content":"Footer_footer__content__LzMgA","footer__text":"Footer_footer__text__Zjc0V","site_url":"Footer_site_url__G02We"};